import React from "react";
import { Typography, ButtonSize } from "@trussle/external-components";
import { IContentfulLink } from "../../../../../types/IContentfulLink";
import { ICTA } from "../../../../../types/ICTA";
import { IBlock } from "../../../../../types/IBlock";
import { GuideCard } from "../../../../GuideCard";
import "./styles.scss";
import { addTracking, CallToActions } from "../../../../CallToActions";
import { PanelWrapper } from "../../../../PanelWrapper";

export const PullOutBlocksPanelCardsWithOverlay: React.FC<IPulloutBlocksPanelCardsWithOverlayProps> = ({ title, blocks, callToActions }) => {
  const cards = blocks.map((block, index) => (
    <div key={index} className="pull-out-blocks-panel-grid-element">
      <GuideCard
        title={block.title}
        category={block.subtitle as string}
        url={block.link as IContentfulLink}
        backgroundImage={block.image!}
        backgroundColor={block.backgroundColour}
      />
    </div>
  ));

  const link = callToActions ? (
    <div className="pull-out-blocks-panel-cta-wrapper" id="pull-out-blocks-panel-cta-wrapper-id">
      <CallToActions
        className="pull-out-blocks-panel-cta-button"
        size={ButtonSize.Large}
        ctas={addTracking("Pull out blocks", ...callToActions)}
        alignment="center"
      />
    </div>
  ) : null;
  return (
    <PanelWrapper>
      <div className="pull-out-blocks-panel">
        <Typography variant="h2">{title}</Typography>
        <div className="pull-out-blocks-panel-grid">
          {cards}
        </div>
        <div className="pull-out-blocks-panel-cta">
          {link}
        </div>
      </div>
    </PanelWrapper>
  );
};

export interface IPulloutBlocksPanelCardsWithOverlayProps {
  title: string | undefined,
  blocks: IBlock[],
  callToActions: ICTA[] | undefined
}
